import React, {useState} from 'react';
import Style from './Navigation.module.scss';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher'
import {Link, useLocation} from "react-router-dom";
import {Box} from "@mui/material";

const links = [
    {
        name: 'Home',
        to: '/',
        active: 'home'
    },
    {
        name: 'About Me',
        to: '/about',
        active: 'about'
    },
    {
        name: 'Projects',
        to: '/projects',
        active: 'projects'
    }
]

function Navigation({darkMode, handleClick}) {
    const location = useLocation()
    const [active, setActive] = useState(location.pathname === '/' ? 'home' : location.pathname.slice(1, location.pathname.length));

    return (
        <Box component={'nav'} width={'100%'}>
            <Box component={'ul'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                 gap={{xs: '2rem', md: '8rem'}}
                 textTransform={'lowercase'} fontSize={'1rem'}>
                {links.map((link, index) => (
                    <Box key={index} component={'li'} className={(link.active === active && !link.type) && Style.active}>
                        <Link to={link.to} onClick={() => setActive(link.active)} className={Style.link}>
                            {!link.type && <p style={{padding: '0.5rem 0'}}>{link.name}</p>}
                            {link.type && <h1>{link.name}</h1>}
                        </Link>
                    </Box>
                ))}
                <li>
                    <ThemeSwitcher darkMode={darkMode} handleClick={handleClick}/>
                </li>
            </Box>
        </Box>
    )
}

export default Navigation